var _rect, _circle, _circle2, _g, _path, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardTicketClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 93,
    viewBox: "0 0 288 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4.99139,
    width: 88,
    height: 88,
    rx: 8,
    transform: "rotate(-1 0 4.99139)",
    fill: "#F9F9F9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 43.2904,
    cy: 47.2907,
    r: 26.6666,
    transform: "rotate(-1 43.2904 47.2907)",
    fill: "url(#paint0_linear_2096_1261)",
    stroke: "url(#paint1_linear_2096_1261)",
    strokeWidth: 0.319361
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.331,
    cy: 47.3297,
    r: 22.5585,
    transform: "rotate(-1 43.331 47.3297)",
    fill: "url(#paint2_linear_2096_1261)",
    stroke: "url(#paint3_linear_2096_1261)",
    strokeWidth: 0.455727
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2096_1261)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2096_1261)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.7207,
    cy: 47.5119,
    r: 7.285,
    stroke: "#FFFDEE",
    strokeWidth: 1.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7206 43.0114L43.7206 47.5114L47.7207 47.5114",
    stroke: "#FFFDEE",
    strokeWidth: 1.43
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.1611 13.4543L89.3479 81.4439",
    stroke: "#C7C7C7",
    strokeDasharray: "5 5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87.9866,
    y: 3.45574,
    width: 198,
    height: 88,
    rx: 8,
    transform: "rotate(-1 87.9866 3.45574)",
    fill: "#F9F9F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2096_1261",
    x1: 66.8975,
    y1: 24.7566,
    x2: 25.8533,
    y2: 74.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.163662,
    stopColor: "#D38F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D38F48",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2096_1261",
    x1: 43.2904,
    y1: 20.4644,
    x2: 19.9515,
    y2: 70.0931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D38F48",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D38F48",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2096_1261",
    x1: 63.383,
    y1: 28.1892,
    x2: 28.5198,
    y2: 70.1161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D38F48",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.930146,
    stopColor: "#D38F48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2096_1261",
    x1: 60.4207,
    y1: 28.417,
    x2: 23.5068,
    y2: 66.6981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D38F48",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2096_1261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6527,
    height: 17.6527,
    fill: "white",
    transform: "translate(34.3113 38.6198) rotate(-1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2096_1261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2114,
    height: 17.2114,
    fill: "white",
    transform: "translate(34.7604 39.0529) rotate(-1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardTicketClock);
export default __webpack_public_path__ + "static/media/RewardTicketClock.bad4e0e6029b606d78fb75086cdb1d28.svg";
export { ForwardRef as ReactComponent };